

































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import axios, { resHandle } from "@/plugins/axios";
import * as _ from "lodash";
import { GetUserHospitals } from "@/request/hospitals";
import { GetPatientsList, GetHospitals } from "@/request/hdr";
import { PostImportHospatients } from "@/request/groups";
import Pagination from "@/components/paginaiton.vue";
import Copy from "@/components/copy.vue";
import PrimaryFilter from "./primary-filter.vue";
@Component({
  components: {
    PrimaryFilter,
    Copy,
    Pagination,
  },
})
export default class SizhenPatients extends Vue {
  @Prop()
  private project: any;
  @Prop()
  private groupId: any;
  // 是否是导入页面
  @Prop()
  private ifShowSave: any;
  // 搜索条件
  private hospitals: any[] = [];
  private saveModel: "add" | "delete" = "add";
  private filters: any = {
    hospital_ids: [],
    范围: [],
    姓名: "",
    性别: "",
    开始年龄: "",
    结束年龄: "",
    开始时间: "",
    结束时间: "",
    年龄段: [],
    自定义年龄: [false],
    体重: [],
    单位: "",
    备孕女性体质辨识: [],
    孕期女性体质辨识: [],
    产后女性体质辨识: [],
    老年人体质类型: [],
    儿童体质类型: [],
    体质辨识: [],
    四诊合参体质辨识: [],
    慢性病: [],
    时间段: "",
    自定义时间段: [false, []],
  };
  // 排序
  private cSortField: string = "更新时间";
  private cSortValue: string = "0";
  // 选择
  private isIndeterminate: boolean = false;
  private checkAll: boolean = false;
  private selectedMessages: any[] = [];
  // 翻页
  private ifLoading: boolean = false;
  private currentPage: any = 1;
  private totalPage: any = 0;
  private totalCount: any = 0;
  private pageSize: any = 10;
  // 列表
  private patients: any[] = [];
  // 项目设置
  private ifShowSet: boolean = false;
  // 高级筛选弹窗
  private ifShowPrimaryFilter: boolean = false;
  private ifPrimarySearched: boolean = false;

  private projectChange() {
    this.$emit("update:project", this.project);
  }
  /**
   * @description 获得可选医院列表
   */
  private fetchHospitals() {
    GetHospitals(this).then((data: any) => {
      this.hospitals = data;
      this.hospitals.unshift({ hospital_id: "", 医院名称: "全部医院" });
    });
  }
  /**
   * @description 跳转数据导出
   */
  private jumpDataExport() {
    this.$router.push({
      path: "/main/hdr/data-export",
    });
  }
  /**
   * @description 获取病人列表
   */
  private fetchPatients() {
    this.ifLoading = true;
    // hospital_ids
    this.filters.hospital_ids = [];
    this.filters["范围"].forEach((item: any) => {
      this.filters.hospital_ids.push(item);
    });
    if (this.filters.hospital_ids.includes("")) {
      this.filters.hospital_ids = [];
    }
    const params: any = {
      center: "治未病数据中心",
      hospital_ids: this.filters.hospital_ids,
      order_field: this.cSortField,
      order_value: this.cSortValue,
      current_page: this.currentPage,
      page_count: this.pageSize,
      姓名: this.filters["姓名"],
      性别: this.filters["性别"],
      年龄段: this.filters["年龄段"],
      体重: this.filters["体重"],
      单位: this.filters["单位"],
      老年人体质类型: this.filters["老年人体质类型"],
      儿童体质类型: this.filters["儿童体质类型"],
      体质辨识: this.filters["体质辨识"],
      四诊合参体质辨识: this.filters["四诊合参体质辨识"],
      备孕女性体质辨识: this.filters["备孕女性体质辨识"],
      孕期女性体质辨识: this.filters["孕期女性体质辨识"],
      产后女性体质辨识: this.filters["产后女性体质辨识"],
      慢性病: this.filters["慢性病"],
    };
    // 时间段
    if (this.filters["自定义时间段"][0]) {
      params.params["开始时间"] = this.filters["自定义时间段"][1][0];
      params.params["结束时间"] = this.filters["自定义时间段"][1][1];
    }
    GetPatientsList(this, params)
      .then((data: any) => {
        this.patients = data.patients;
        this.totalPage = data.total_page;
        this.totalCount = data.total_count;
        if (this.saveModel === "add") {
          this.checkAllMessages(false);
          this.autoCheckSelectedMessages(true);
        } else {
          this.checkAllMessages(true);
          this.autoCheckSelectedMessages(false);
        }
        const checkedCount = this.countHowMuchCurrentPageMessagesSelected();
        this.checkAll = checkedCount === this.patients.length;
        this.isIndeterminate =
          checkedCount > 0 && checkedCount < this.patients.length;
      })
      .finally(() => {
        this.ifLoading = false;
      });
  }
  /**
   * @description 搜索
   */
  private search() {
    this.currentPage = 1;
    this.saveModel = "delete";
    this.fetchPatients();
  }
  /**
   * @description 处理高级筛选
   */
  private primaryFilterChange(val) {
    this.ifShowPrimaryFilter = false;
    this.$set(this, "filters", val);
    this.currentPage = 1;
    this.saveModel = "delete";
    this.ifPrimarySearched = true;
    this.fetchPatients();
  }
  /**
   * @description 重置高级筛选条件
   */
  private resetPrimarySearch() {
    this.ifPrimarySearched = false;
    this.currentPage = 1;
    this.$set(this, "filters", {
      hospital_ids: [],
      范围: [],
      姓名: "",
      性别: "",
      开始年龄: "",
      结束年龄: "",
      开始时间: "",
      结束时间: "",
      年龄段: [],
      自定义年龄: [false],
      体重: [],
      单位: "",
      备孕女性体质辨识: [],
      孕期女性体质辨识: [],
      产后女性体质辨识: [],
      老年人体质类型: [],
      儿童体质类型: [],
      体质辨识: [],
      四诊合参体质辨识: [],
      慢性病: [],
      时间段: "",
      自定义时间段: [false, []],
    });
    this.saveModel = "add";
    this.fetchPatients();
  }
  /**
   * @description 处理翻页器的当前页变化
   */
  private handleCurrentPageChange(val) {
    this.currentPage = val;
    this.fetchPatients();
  }
  /**
   * @description 处理排序变化
   */
  private handleSortChange(ev: any) {
    this.cSortField = ev["prop"];
    this.cSortValue = ev["order"] === "ascending" ? "1" : "0";
    this.fetchPatients();
  }
  // 勾选
  /**
   * @description 给所有message勾选上
   */
  private checkAllMessages(isChecked: boolean) {
    this.patients.forEach((message: any, index: number) => {
      this.$set(this.patients[index], "isChecked", isChecked);
    });
    this.isIndeterminate = false;
    this.checkAll = isChecked ? true : false;
  }
  /**
   * @description 增加一个数据到已选列表
   */
  private addOneMessageToSelectedMessages(message: any) {
    this.selectedMessages.push(message);
    this.selectedMessages = _.uniq(this.selectedMessages);
  }
  /**
   * @description 从已选列表中删除一条数据
   */
  private deleteOneMessageFromSelectedMessages(message: any) {
    const index = this.selectedMessages.findIndex(
      (selectedMessage: any) =>
        selectedMessage.patient_id === message.patient_id
    );
    if (index !== -1) {
      this.selectedMessages.splice(index, 1);
    }
  }
  /**
   * @description 增加当前页面所有的消息进入已选列表
   */
  private addAllMessagesToSelectedMessages() {
    this.patients.forEach((message: any) => {
      this.selectedMessages.push(message);
    });
    this.selectedMessages = _.uniq(this.selectedMessages);
  }
  /**
   * @description 将当前页面的所有数据，从已选列表中删除
   */
  private deleteAllMessagesFromSelectedMessages() {
    this.patients.forEach((message: any) => {
      const targetIndex = this.selectedMessages.findIndex(
        (selectedMessage: any) =>
          selectedMessage.patient_id === message.patient_id
      );
      if (targetIndex !== -1) {
        this.selectedMessages.splice(targetIndex, 1);
      }
    });
  }
  /**
   * @description 统计当前页面有多少数据被选中
   */
  private countHowMuchCurrentPageMessagesSelected() {
    let checkedCount = 0;
    this.patients.forEach((message: any) => {
      if (message.isChecked) {
        checkedCount++;
      }
    });
    return checkedCount;
  }
  /**
   * @description 翻页后自动勾选上已经选择的数据
   */
  private autoCheckSelectedMessages(isChecked: boolean) {
    this.patients.forEach((message: any) => {
      const targetIndex = this.selectedMessages.findIndex(
        (selectedMessage: any) =>
          selectedMessage.patient_id === message.patient_id
      );
      if (targetIndex !== -1) {
        message.isChecked = isChecked;
      }
    });
  }
  /**
   * @description 处理点击全选
   */
  private handleCheckAllChange(val) {
    if (val) {
      this.checkAllMessages(true);
      if (this.saveModel === "add") {
        this.addAllMessagesToSelectedMessages();
      } else if (this.saveModel === "delete") {
        this.deleteAllMessagesFromSelectedMessages();
      }
    } else {
      this.checkAllMessages(false);
      if (this.saveModel === "add") {
        this.deleteAllMessagesFromSelectedMessages();
      } else if (this.saveModel === "delete") {
        this.addAllMessagesToSelectedMessages();
      }
    }
  }
  /**
   * @description 处理单个勾选
   */
  private handleCheckedMessageChange(val, item) {
    if (val) {
      if (this.saveModel === "add") {
        this.addOneMessageToSelectedMessages(item);
      } else if (this.saveModel === "delete") {
        this.deleteOneMessageFromSelectedMessages(item);
      }
    } else {
      if (this.saveModel === "add") {
        this.deleteOneMessageFromSelectedMessages(item);
      } else if (this.saveModel === "delete") {
        this.addOneMessageToSelectedMessages(item);
      }
    }
    const checkedCount = this.countHowMuchCurrentPageMessagesSelected();
    this.checkAll = checkedCount === this.patients.length;
    this.isIndeterminate =
      checkedCount > 0 && checkedCount < this.patients.length;
  }
  /**
   * @description 某行被点击
   */
  private rowClicked(row, column, event) {
    this.$router.push({
      path: "/main/hdr/patient-detail",
      query: { patient_id: row.patient_id },
    });
  }
  /**
   * @description 保存并导入
   */
  private save() {
    const idList: any[] = [];
    this.selectedMessages.forEach((message: any) => {
      idList.push(message.hpt_id);
    });
    const params: any = {
      project_id: this.project.project_id,
      group_id: this.groupId,
    };
    if (this.saveModel === "add") {
      if (idList.length > 0) {
        params["hpt_ids"] = idList;
      } else {
        this.$message.error("请至少选择一条数据");
        return;
      }
      params["is_use_filter"] = false;
    } else if (this.saveModel === "delete") {
      params["is_use_filter"] = true;
      if (idList.length > 0) {
        params["del_hpt_ids"] = idList;
      }
      const hospitalIds: any[] = [];
      this.filters["范围"].forEach((item: any) => {
        hospitalIds.push(item.hospital_id);
      });
      params["filters"] = {
        hospital_ids: hospitalIds,
        姓名: this.filters["姓名"],
        性别: this.filters["性别"],
        年龄段: this.filters["年龄段"],
        体重: this.filters["体重"],
        单位: this.filters["单位"],
        老年人体质类型: this.filters["老年人体质类型"],
        儿童体质类型: this.filters["儿童体质类型"],
        体质辨识: this.filters["体质辨识"],
        四诊合参体质辨识: this.filters["四诊合参体质辨识"],
        备孕女性体质辨识: this.filters["备孕女性体质辨识"],
        孕期女性体质辨识: this.filters["孕期女性体质辨识"],
        产后女性体质辨识: this.filters["产后女性体质辨识"],
        慢性病: this.filters["慢性病"],
      };
      // 时间段
      if (this.filters["自定义时间段"][0]) {
        params["开始时间"] = this.filters["自定义时间段"][1][0];
        params["结束时间"] = this.filters["自定义时间段"][1][1];
      }
    }
    const loading = this.$loading({
      text: "加载中...",
    });
    PostImportHospatients(this, params)
      .then((data: any) => {
        this.$message.success("导入成功!");
        this.$router.back();
      })
      .finally(() => {
        loading.close();
      });
  }
  private mounted() {
    this.fetchHospitals();
    this.fetchPatients();
  }
}
